"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _eventHandler = require("@active/react-utils/eventHandler");
var _classnames = _interopRequireDefault(require("classnames"));
var _dom = require("@active/react-utils/dom");
var _accessibility = require("@active/react-utils/accessibility");
var _activateStrategies = require("@active/react-utils/accessibility/listAlike/activateStrategies");
var _first = _interopRequireDefault(require("lodash/fp/first"));
var _last = _interopRequireDefault(require("lodash/fp/last"));
var _find2 = _interopRequireDefault(require("lodash/fp/find"));
var _defer = _interopRequireDefault(require("lodash/fp/defer"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _negate = _interopRequireDefault(require("lodash/fp/negate"));
var _indexOf = _interopRequireDefault(require("lodash/fp/indexOf"));
var _map = _interopRequireDefault(require("lodash/fp/map"));
var _forEach = _interopRequireDefault(require("lodash/fp/forEach"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _MenuContext = require("./MenuContext");
var _Popper = _interopRequireDefault(require("../Popper"));
var _ActiveUIContext = require("../ActiveUIContext");
var _itemVisitUtils = require("./itemVisitUtils");
var _ComboBox = require("../ComboBox");
var _usePopperContext2 = _interopRequireDefault(require("../Popper/usePopperContext"));
var _constants = require("../constants");
var _useSearchMenuContext2 = _interopRequireDefault(require("../SearchInput/useSearchMenuContext"));
var _excluded = ["children", "closeOn", "className", "distance", "focusOnOpen", "layout", "isItemSelected", "onClose", "onOpen", "onItemSelect", "open", "placement", "refElement", "rootElement", "sameWidth", "type", "closeExceptions"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function doWhen(predicate) {
  return function (action) {
    return function (operator) {
      predicate(operator) && action(operator);
    };
  };
}
function doWhenExists(action) {
  return doWhen((0, _negate["default"])(_isNil["default"]))(action);
}
var getAvailableItems = function getAvailableItems(root) {
  return Array.prototype.slice.call((root === null || root === void 0 ? void 0 : root.querySelectorAll('.menu-item:not(.disabled)')) || []);
};
var getColumns = function getColumns(root) {
  return Array.prototype.slice.call(root === null || root === void 0 ? void 0 : root.querySelectorAll('.menu-item-list'));
};
var getColumn = function getColumn(root) {
  return function (itemValue) {
    return (0, _compose["default"])((0, _find2["default"])(function (column) {
      return !!column.querySelector("[data-value=\"".concat(itemValue, "\"]"));
    }), getColumns)(root);
  };
};
var getItemByValue = function getItemByValue(root, activeValue) {
  return root.querySelector(".menu-item[data-value=\"".concat(activeValue, "\"]"));
};
var getInitialAvailableItems = function getInitialAvailableItems(root) {
  var includeSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return Array.prototype.slice.call((root === null || root === void 0 ? void 0 : root.querySelectorAll("".concat(includeSearch ? '.menu-search input, ' : '', ".menu-item:not(.disabled)"))) || []);
};
var getInitialActiveItem = function getInitialActiveItem(multiColumn) {
  var includeSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (root) {
    var _find;
    var container = multiColumn ? (0, _first["default"])(getColumns(root)) : root;
    var availableItems = getInitialAvailableItems(container, includeSearch);
    var firstAvailableItem = (0, _first["default"])(availableItems);
    if (includeSearch && (firstAvailableItem === null || firstAvailableItem === void 0 ? void 0 : firstAvailableItem.tagName) === 'INPUT') {
      return firstAvailableItem;
    }
    return (_find = (0, _find2["default"])(function (item) {
      return /\bselected\b/.test(item.className);
    })(availableItems)) !== null && _find !== void 0 ? _find : firstAvailableItem;
  };
};
var getSelectedItem = function getSelectedItem(root) {
  var availableItems = getAvailableItems(root);
  return (0, _find2["default"])(function (item) {
    return /\bselected\b/.test(item.className);
  })(availableItems);
};
var isMultiColumn = function isMultiColumn(layout) {
  return layout === 'multi-column' || layout === 'multi-column-with-divider';
};
var scrollIntoView = function scrollIntoView(multiColumn) {
  return function (root) {
    return function (element) {
      if (element) {
        (0, _dom.scrollToFullyVisibleY)({
          container: multiColumn ? element.parentNode : root,
          element: element
        });
      }
    };
  };
};
var isFullyVisible = function isFullyVisible(container) {
  return function (element) {
    if (element) {
      var elementVisibleTop = element.offsetTop;
      var elementVisibleBottom = element.offsetTop + element.clientHeight;
      var containerViewTop = container.scrollTop;
      var containerViewBottm = container.scrollTop + container.clientHeight;
      return elementVisibleTop >= containerViewTop && elementVisibleBottom <= containerViewBottm;
    }
    return false;
  };
};
var scrollFirstSelectedItemsIntoView = function scrollFirstSelectedItemsIntoView(mutiColumn) {
  return function (root) {
    return (0, _compose["default"])((0, _forEach["default"])(scrollIntoView(mutiColumn)(root)), (0, _map["default"])(getSelectedItem), getColumns)(root);
  };
};
var withFocusableOf = function withFocusableOf(selector) {
  return (0, _compose["default"])(selector, (0, _dom.tabbable)({
    displayCheck: 'none'
  }));
};
var Menu = function Menu(_ref, ref) {
  var children = _ref.children,
    _ref$closeOn = _ref.closeOn,
    closeOn = _ref$closeOn === void 0 ? 'escape' : _ref$closeOn,
    className = _ref.className,
    distance = _ref.distance,
    _ref$focusOnOpen = _ref.focusOnOpen,
    focusOnOpen = _ref$focusOnOpen === void 0 ? true : _ref$focusOnOpen,
    layout = _ref.layout,
    isItemSelected = _ref.isItemSelected,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    onItemSelect = _ref.onItemSelect,
    open = _ref.open,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    refElement = _ref.refElement,
    rootElement = _ref.rootElement,
    sameWidth = _ref.sameWidth,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'menu' : _ref$type,
    _ref$closeExceptions = _ref.closeExceptions,
    closeExceptions = _ref$closeExceptions === void 0 ? [] : _ref$closeExceptions,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useSearchMenuContext = (0, _useSearchMenuContext2["default"])(),
    enableFocusItem = _useSearchMenuContext.enableFocusItem;
  var multiColumn = isMultiColumn(layout);
  var innerRef = (0, _react.useRef)(null);
  var rootRef = ref || innerRef;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeItem = _useState2[0],
    setActiveItem = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    searchText = _useState4[0],
    setSearchText = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    hasHeader = _useState6[0],
    setHasHeader = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    hasFooter = _useState8[0],
    setHasFooter = _useState8[1];
  var calculatedChildren = (0, _react.useMemo)(function () {
    return (0, _itemVisitUtils.filterItems)(searchText, children);
  }, [children, searchText]);
  var scrollSelectedItemIntoView = (0, _react.useCallback)(function (selectedItem) {
    var selectedEl = getItemByValue(rootRef.current, selectedItem);
    var container = multiColumn ? selectedEl.parentNode : rootRef.current;
    var isActiveElementFullyVisible = isFullyVisible(container)(selectedEl);
    if (!isActiveElementFullyVisible) {
      scrollIntoView(multiColumn)(container)(selectedEl);
    }
  }, [rootRef, multiColumn]);
  var focusActiveItem = (0, _react.useCallback)(function () {
    doWhenExists(function (itemToActivate) {
      itemToActivate.focus({
        preventScroll: true
      });
    })(getInitialActiveItem(multiColumn, true)(rootRef.current));
  }, [multiColumn, rootRef]);
  (0, _ComboBox.useListBox)({
    listBoxRef: enableFocusItem ? rootRef : undefined,
    onFocusListBox: enableFocusItem ? focusActiveItem : _noop["default"]
  });
  var handleClose = (0, _react.useCallback)(function handleCloseWithDefer(e) {
    (0, _defer["default"])(function () {
      onClose === null || onClose === void 0 || onClose(e);
    });
  }, [onClose]);
  var handleOpen = (0, _react.useCallback)(function handleOpenWithDefer(e) {
    (0, _defer["default"])(function () {
      onOpen === null || onOpen === void 0 || onOpen(e);
    });
  }, [onOpen]);
  var handleItemSelect = (0, _react.useCallback)(function (value) {
    onItemSelect === null || onItemSelect === void 0 || onItemSelect(value);
    if (closeOn === 'select') {
      handleClose === null || handleClose === void 0 || handleClose();
      return;
    }
    var strValue = typeof value === 'number' ? String(value) : value;
    setActiveItem(strValue);
    scrollSelectedItemIntoView(strValue);
  }, [closeOn, handleClose, onItemSelect, scrollSelectedItemIntoView]);
  var menuCtx = (0, _react.useMemo)(function () {
    return {
      activeItem: activeItem,
      isSelected: isItemSelected,
      itemCount: (0, _itemVisitUtils.getFlattenItems)(calculatedChildren).length,
      onItemClick: handleItemSelect,
      onItemConfirmKeyDown: handleItemSelect,
      onSearchTextChange: setSearchText,
      onCloseMenu: handleClose,
      searchText: searchText,
      type: type
    };
  }, [activeItem, calculatedChildren, handleItemSelect, handleClose, searchText, type, isItemSelected]);
  _react["default"].useEffect(function handleClickEscape() {
    return open ? (0, _eventHandler.listenClickEscape)(function () {
      handleClose === null || handleClose === void 0 || handleClose();
    }, [rootRef].concat((0, _toConsumableArray2["default"])(closeExceptions))) : undefined;
  }, [open, rootRef, closeExceptions, handleClose]);
  _react["default"].useEffect(function handleKeyboardEscape() {
    return open ? (0, _eventHandler.listenKeyboardEscape)(function (e) {
      handleClose === null || handleClose === void 0 || handleClose();
      e.stopPropagation();
    }, [rootRef]) : undefined;
  }, [open, rootRef, handleClose]);
  (0, _react.useEffect)(function clearSearchTextOnClose() {
    if (!open) {
      setSearchText('');
    }
  }, [open]);
  (0, _react.useEffect)(function activateItemOnOpen() {
    if (open) {
      focusOnOpen && enableFocusItem && focusActiveItem();
      scrollFirstSelectedItemsIntoView(multiColumn)(rootRef.current);
    }
  }, [focusActiveItem, focusOnOpen, open, multiColumn, rootRef, enableFocusItem]);
  (0, _react.useEffect)(function handleOpenOnOpen() {
    if (open) {
      handleOpen === null || handleOpen === void 0 || handleOpen();
    }
  }, [open, handleOpen]);
  (0, _react.useEffect)(function updateActiveItem() {
    if (open) {
      doWhenExists(function (itemToActivate) {
        setActiveItem(itemToActivate.getAttribute('data-value'));
      })(getInitialActiveItem(multiColumn)(rootRef.current));
    } else {
      setActiveItem(null);
    }
  }, [open, multiColumn, rootRef, searchText]);
  (0, _react.useEffect)(function updateHasHeaderAndHasFooterOnOpen() {
    var _rootRef$current, _rootRef$current2;
    if (!open) return;
    var headerEl = (_rootRef$current = rootRef.current) === null || _rootRef$current === void 0 ? void 0 : _rootRef$current.querySelector('.menu-header');
    var footerEl = (_rootRef$current2 = rootRef.current) === null || _rootRef$current2 === void 0 ? void 0 : _rootRef$current2.querySelector('.menu-footer');
    setHasHeader(!(0, _isNil["default"])(headerEl));
    setHasFooter(!(0, _isNil["default"])(footerEl));
  }, [rootRef, open]);
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    if (e.key === _constants.KEY_VALUES.TAB && (e.target === withFocusableOf(e.shiftKey ? _first["default"] : _last["default"])(rootRef.current) || e.target === rootRef.current && e.shiftKey)) {
      e.preventDefault();
      handleClose === null || handleClose === void 0 || handleClose(e);
    }
  }, [handleClose, rootRef]);
  var rowNavItemFilter = (0, _react.useCallback)(function (item) {
    var _getColumn;
    return !!(!multiColumn || (_getColumn = getColumn(rootRef.current)(activeItem)) !== null && _getColumn !== void 0 && _getColumn.contains(item)) && !item.classList.contains('disabled');
  }, [activeItem, rootRef, multiColumn]);
  var keyboardNavOptions = {};
  var keyboardDownUpActivateItem = (0, _activateStrategies.composeStrategy)(_activateStrategies.scrollTowardEndY, _activateStrategies.scrollNextItemIntoViewY, _activateStrategies.focusNextItem, _activateStrategies.activateNextItem, _activateStrategies.adjustMetasForInitialFocus);
  var keyboardLeftRightActiveItem = (0, _activateStrategies.composeStrategy)(multiColumn ? _activateStrategies.scrollNextItemIntoViewY : _activateStrategies.identityStrategy, _activateStrategies.scrollNextItemIntoViewX, _activateStrategies.focusNextItem, _activateStrategies.activateNextItem, _activateStrategies.adjustMetasForInitialFocus);
  if (!enableFocusItem) {
    keyboardNavOptions = {
      autoFocus: false,
      circularMove: true
    };
    keyboardDownUpActivateItem = (0, _activateStrategies.composeStrategy)(_activateStrategies.scrollTowardEndY, _activateStrategies.scrollNextItemIntoViewY, _activateStrategies.activateNextItem);
    keyboardLeftRightActiveItem = (0, _activateStrategies.composeStrategy)(multiColumn ? _activateStrategies.scrollNextItemIntoViewY : _activateStrategies.identityStrategy, _activateStrategies.scrollNextItemIntoViewX, _activateStrategies.activateNextItem, _activateStrategies.adjustMetasForInitialFocus);
  }
  (0, _accessibility.useListKeyboardNav)(_objectSpread({
    containerRef: rootRef,
    idAttribute: 'data-value',
    itemFilter: rowNavItemFilter,
    activated: activeItem,
    setActivated: setActiveItem,
    forwardCodes: ['ArrowDown'],
    backwardCodes: ['ArrowUp'],
    activateItem: keyboardDownUpActivateItem
  }, keyboardNavOptions));
  var columnNavItemFilter = (0, _react.useCallback)(function (item) {
    var activeItemRow = (0, _compose["default"])((0, _indexOf["default"])(getItemByValue(rootRef.current, activeItem)), getAvailableItems, getColumn(rootRef.current))(activeItem);
    var availableItemsInItemColumn = (0, _compose["default"])(getAvailableItems, getColumn(rootRef.current))(item.dataset.value);
    return availableItemsInItemColumn.length - 1 > activeItemRow ? availableItemsInItemColumn.at(activeItemRow) === item : availableItemsInItemColumn.at(-1) === item;
  }, [activeItem, rootRef]);
  (0, _accessibility.useListKeyboardNav)(_objectSpread({
    containerRef: rootRef,
    idAttribute: 'data-value',
    itemFilter: columnNavItemFilter,
    activated: activeItem,
    setActivated: setActiveItem,
    forwardCodes: multiColumn ? ['ArrowRight'] : [],
    backwardCodes: multiColumn ? ['ArrowLeft'] : [],
    activateItem: keyboardLeftRightActiveItem
  }, keyboardNavOptions));
  var _usePopperContext = (0, _usePopperContext2["default"])(),
    popperContextRef = _usePopperContext.rootRef;
  var currentRootElement = (0, _react.useMemo)(function () {
    var currentElement = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.tagName) === 'BODY' && popperContextRef && popperContextRef.current ? popperContextRef.current : rootElement;
    return currentElement;
  }, [popperContextRef, popperContextRef === null || popperContextRef === void 0 ? void 0 : popperContextRef.current, rootElement]);
  return open ? (/*#__PURE__*/_reactDom["default"].createPortal(/*#__PURE__*/_react["default"].createElement(_Popper["default"], {
    distance: distance,
    placement: placement,
    refElement: refElement,
    className: className ? "popper-".concat(className) : '',
    sameWidth: sameWidth
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: rootRef,
    className: (0, _classnames["default"])('menu', {
      'menu-header-sticky': hasHeader,
      'menu-footer-sticky': hasFooter,
      'menu-multi-column': layout === 'multi-column' || layout === 'multi-column-with-divider',
      'menu-with-vertical-divider': layout === 'multi-column-with-divider'
    }, className),
    onKeyDown: handleKeyDown,
    "data-testid": "menu-root",
    tabIndex: -1
  }, rest), /*#__PURE__*/_react["default"].createElement(_MenuContext.MenuProvider, {
    value: menuCtx
  }, calculatedChildren))), currentRootElement)) : null;
};
var Composed = (0, _ActiveUIContext.withRootElement)((0, _compose["default"])(_react.memo, _react.forwardRef)(Menu));
var _default = exports["default"] = Composed;